// extracted by mini-css-extract-plugin
export default {"pickerMoldDetails":"MoldDetails_pickerMoldDetails__8gnPG"};